export const paletteV2 = {
  // extended brand palette
  terracotta: {
    mainChannel: '132 64 37',
    10: '#F3ECE9',
    50: '#F3ECE9',
    100: '#D9C4BB',
    200: '#C6A79B',
    300: '#AD7F6D',
    400: '#9D6651',
    500: '#844025',
    600: '#783A22',
    700: '#5E2D1A',
    800: '#492314',
    900: '#371B10',
  },
  maroonVelvet: {
    mainChannel: '60 16 30',
    10: '#ECE7E9',
    50: '#ECE7E9',
    100: '#C3B5B9',
    200: '#A59198',
    300: '#7C5F68',
    400: '#63404B',
    500: '#3C101E',
    600: '#370F1B',
    700: '#2B0B15',
    800: '#210911',
    900: '#19070D',
  },
  leafGreen: {
    mainChannel: '82 107 49',
    10: '#ECECEA',
    50: '#ECECEA',
    100: '#C4C4BC',
    200: '#A8A89C',
    300: '#80806F',
    400: '#676753',
    500: '#414128',
    600: '#3B3B24',
    700: '#2E2E1C',
    800: '#242416',
    900: '#1B1B11',
  },
  burntOrange: {
    mainChannel: '176 68 0',
    10: '#FBEFE8',
    50: '#FBEFE8',
    100: '#F1CCB8',
    200: '#EAB496',
    300: '#E19266',
    400: '#DB7D49',
    500: '#D25C1B',
    600: '#BF5419',
    700: '#954113',
    800: '#74330F',
    900: '#58270B',
  },
  freshWaterBlue: {
    mainChannel: '0 124 146',
    10: '#F5F6F9',
    50: '#F5F6F9',
    100: '#E0E2EC',
    200: '#D1D5E2',
    300: '#BDC1D5',
    400: '#B0B5CD',
    500: '#9CA3C1',
    600: '#8E94B0',
    700: '#6F7489',
    800: '#565A6A',
    900: '#424451',
  },
  // extended neutral palette
  warmLinen: {
    mainChannel: '244 238 231',
    10: '#FEFEFD',
    50: '#FEFEFD',
    100: '#FCFBF8',
    200: '#FBF9F4',
    300: '#F9F7EF',
    400: '#F8F5EC',
    500: '#F6F3E7',
    600: '#E0DDD2',
    700: '#AFADA4',
    800: '#87867F',
    900: '#676661',
  },
  mono: {
    mainChannel: '50 52 51',
    10: '#FAFAFA',
    50: '#FAFAFA',
    100: '#F5F5F5',
    200: '#D2D2D2',
    300: '#BEBEBE',
    400: '#B1B1B1',
    500: '#9E9E9E',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
  },
  // extended status palette
  rosewood: {
    mainChannel: '101 0 11',
    10: '#F0E6E7',
    50: '#F0E6E7',
    100: '#CFB0B3',
    200: '#B88A8F',
    300: '#98545C',
    400: '#84333C',
    500: '#65000B',
    600: '#5C000A',
    700: '#480008',
    800: '#380006',
    900: '#2A0005',
  },
  white: '#FFFFFF',
  black: '#000000',
} as Record<string, any>;

export const primaryColorsV2 = {
  ...paletteV2.terracotta,
  solidActiveBorder: 'var(--fortress-palette-brand-terracotta-800)',
  solidActiveBg: 'var(--fortress-palette-brand-terracotta-800)',
  solidDisabledColor: 'var(--fortress-palette-brand-mono-500)',
  solidDisabledBorder: 'var(--fortress-palette-brand-mono-200)',
  solidDisabledBg: 'var(--fortress-palette-brand-mono-200)',

  outlinedBg: 'transparent',

  outlinedBorder: 'var(--fortress-palette-brand-terracotta-500)',
  outlinedHoverBg: 'var(--fortress-palette-brand-terracotta-100)',
  outlinedHoverBorder: 'var(--fortress-palette-brand-terracotta-500)',
  outlinedActiveBorder: 'var(--fortress-palette-brand-terracotta-500)',
  outlinedActiveBg: 'var(--fortress-palette-brand-terracotta-200)',
  outlinedActiveColor: 'var(--fortress-palette-brand-terracotta-500)',
  outlinedDisabledColor: 'var(--fortress-palette-brand-mono-500)',
  outlinedDisabledBorder: 'var(--fortress-palette-brand-mono-500)',
  outlinedDisabledBg: 'transparent',

  plainColor: 'var(--fortress-palette-brand-maroonVelvet-500)',
  plainHoverColor: 'var(--fortress-palette-brand-terracotta-500)',
  plainHoverBg: 'var(--fortress-palette-brand-terracotta-50)',
  // plainHoverBg: 'transparent',
  plainActiveColor: 'var(--fortress-palette-brand-maroonVelvet-500)',
  // plainActiveBg: 'transparent',
  plainActiveBg: 'var(--fortress-palette-brand-terracotta-100)',

  softActiveColor: 'var(--fortress-palette-brand-terracotta-500)',

  plainDisabledBg: 'transparent',
  plainDisabledColor: 'var(--fortress-palette-brand-mono-500)',
  plainDisabledBorder: 'transparent',

  softDisabledBg: 'var(--fortress-palette-brand-mono-200)',
  softDisabledColor: 'var(--fortress-palette-brand-mono-500)',
  softDisabledBorder: 'var(--fortress-palette-brand-mono-200)',
};

export const successColorsV2 = {
  ...paletteV2.leafGreen,
  outlinedBg: 'transparent',
};

export const dangerColorsV2 = {
  ...paletteV2.rosewood,
  outlinedBg: 'transparent',
  plainDisabledBg: 'transparent',
  plainDisabledColor: 'var(--fortress-palette-brand-mono-500)',
  plainDisabledBorder: 'transparent',

  solidDisabledBg: 'var(--fortress-palette-brand-mono-200)',
  solidDisabledColor: 'var(--fortress-palette-brand-mono-500)',
  solidDisabledBorder: 'var(--fortress-palette-brand-mono-200)',

  softDisabledBg: 'var(--fortress-palette-brand-mono-200)',
  softDisabledColor: 'var(--fortress-palette-brand-mono-500)',
  softDisabledBorder: 'var(--fortress-palette-brand-mono-200)',

  outlinedBorder: 'var(--fortress-palette-brand-rosewood-500)',
  outlinedHoverColor: 'var(--fortress-palette-brand-rosewood-500)',
  outlinedHoverBg: 'var(--fortress-palette-brand-rosewood-100)',
  outlinedHoverBorder: 'var(--fortress-palette-brand-rosewood-500)',
  outlinedActiveColor: 'var(--fortress-palette-brand-warmLinen-500)',
  outlinedActiveBg: 'var(--fortress-palette-brand-rosewood-400)',
  outlinedActiveBorder: 'var(--fortress-palette-brand-rosewood-500)',

  outlinedDisabledBg: 'transparent',
  outlinedDisabledColor: 'var(--fortress-palette-brand-mono-500)',
  outlinedDisabledBorder: 'var(--fortress-palette-brand-mono-300)',
};

export const warningColorsV2 = {
  ...paletteV2.burntOrange,
  outlinedBg: 'transparent',
  plainDisabledBg: 'transparent',
  plainDisabledColor: 'var(--fortress-palette-brand-mono-500)',
  plainDisabledBorder: 'transparent',

  solidDisabledBg: 'var(--fortress-palette-brand-mono-200)',
  solidDisabledColor: 'var(--fortress-palette-brand-mono-500)',
  solidDisabledBorder: 'var(--fortress-palette-brand-mono-200)',

  softDisabledBg: 'var(--fortress-palette-brand-mono-200)',
  softDisabledColor: 'var(--fortress-palette-brand-mono-500)',
  softDisabledBorder: 'var(--fortress-palette-brand-mono-200)',

  outlinedDisabledBg: 'transparent',
  outlinedDisabledColor: 'var(--fortress-palette-brand-mono-500)',
  outlinedDisabledBorder: 'var(--fortress-palette-brand-mono-300)',
};

export const neutralColorsV2 = {
  ...paletteV2.maroonVelvet,
  solidColor: 'var(--fortress-palette-brand-warmLinen-500)',
  solidActiveColor: 'var(--fortress-palette-brand-warmLinen-500)',
  solidActiveBg: 'var(--fortress-palette-brand-maroonVelvet-500)',
  solidActiveBorder: 'var(--fortress-palette-brand-maroonVelvet-500)',
  solidHoverColor: 'var(--fortress-palette-brand-warmLinen-500)',
  solidHoverBg: 'var(--fortress-palette-brand-maroonVelvet-400)',
  solidHoverBorder: 'var(--fortress-palette-brand-maroonVelvet-400)',
  solidDisabledBg: 'var(--fortress-palette-brand-mono-200)',
  solidDisabledColor: 'var(--fortress-palette-brand-mono-500)',
  solidDisabledBorder: 'var(--fortress-palette-brand-mono-200)',

  softColor: 'var(--fortress-palette-brand-maroonVelvet-500)',
  softActiveColor: 'var(--fortress-palette-brand-maroonVelvet-500)',
  softActiveBg: 'var(--fortress-palette-brand-maroonVelvet-500)',
  softActiveBorder: 'var(--fortress-palette-brand-maroonVelvet-500)',
  softHoverColor: 'var(--fortress-palette-brand-maroonVelvet-500)',
  softHoverBg: 'var(--fortress-palette-brand-maroonVelvet-400)',
  softHoverBorder: 'var(--fortress-palette-brand-maroonVelvet-400)',
  softDisabledBg: 'var(--fortress-palette-brand-mono-200)',
  softDisabledColor: 'var(--fortress-palette-brand-mono-500)',
  softDisabledBorder: 'var(--fortress-palette-brand-mono-200)',

  outlinedBg: 'transparent',
  outlinedColor: 'var(--fortress-palette-brand-maroonVelvet-500)',
  outlinedBorder: 'var(--fortress-palette-brand-maroonVelvet-500)',

  outlinedActiveColor: 'var(--fortress-palette-brand-warmLinen-500)',
  outlinedActiveBorder: 'var(--fortress-palette-brand-maroonVelvet-500)',
  outlinedActiveBg: 'var(--fortress-palette-brand-maroonVelvet-500)',
  outlinedHoverColor: 'var(--fortress-palette-brand-warmLinen-500)',
  outlinedHoverBorder: 'var(--fortress-palette-brand-maroonVelvet-500)',
  outlinedHoverBg: 'var(--fortress-palette-brand-maroonVelvet-400)',
  outlinedDisabledBorder: 'var(--fortress-palette-brand-mono-300)',
  outlinedDisabledBg: 'transparent',
  outlinedDisabledColor: 'var(--fortress-palette-brand-mono-500)',

  plainColor: 'var(--fortress-palette-brand-maroonVelvet-500)',
  plainActiveColor: 'var(--fortress-palette-brand-maroonVelvet-500)',
  plainActiveBg: 'transparent',
  plainActiveBorder: 'transparent',
  plainHoverColor: 'var(--fortress-palette-brand-maroonVelvet-500)',
  plainHoverBg: 'transparent',
  plainHoverBorder: 'transparent',
  plainDisabledColor: 'var(--fortress-palette-brand-mono-500)',

  plainDisabledBg: 'transparent',
  plainDisabledBorder: 'transparent',
};
